import { apiService } from './api.service';
import { ENDPOINTS } from '../config/api';
import { Schedule } from '../types';

interface CreateScheduleData {
  term: string;
  year: number;
  term_number?: string | null;
  is_planned: boolean;
  course_ids: number[];
  plan_id?: number | null;
}

interface UpdateScheduleData {
  term?: string;
  year?: number;
  term_number?: string | null;
  is_planned?: boolean;
  course_ids?: number[];
  plan_id?: number | null;
}

class ScheduleService {
  async getSchedules(plan_id?: number): Promise<Schedule[]> {
    const config = plan_id ? { params: { plan_id } } : {};
    return apiService.get<Schedule[]>(ENDPOINTS.SCHEDULES, config);
  }

  async getSchedule(id: number): Promise<Schedule> {
    return apiService.get<Schedule>(ENDPOINTS.SCHEDULE_DETAIL(id));
  }

  async createSchedule(data: CreateScheduleData): Promise<Schedule> {
    return apiService.post<Schedule>(ENDPOINTS.SCHEDULES, data);
  }

  async updateSchedule(id: number, data: UpdateScheduleData): Promise<Schedule> {
    return apiService.put<Schedule>(ENDPOINTS.SCHEDULE_DETAIL(id), data);
  }

  async deleteSchedule(id: number): Promise<void> {
    return apiService.delete(ENDPOINTS.SCHEDULE_DETAIL(id));
  }

  async addCourse(scheduleId: number, courseId: number): Promise<Schedule> {
    return apiService.post<Schedule>(`${ENDPOINTS.SCHEDULE_DETAIL(scheduleId)}/courses`, { course_id: courseId });
  }

  async removeCourse(scheduleId: number, courseId: number): Promise<void> {
    return apiService.delete(`${ENDPOINTS.SCHEDULE_DETAIL(scheduleId)}/courses/${courseId}`);
  }
}

export const scheduleService = new ScheduleService();
